import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "./lib/auth";
import ProtectedRoute from "./components/ProtectedRoute";
import Layout from "./components/Layout";

import Login from "./pages/Login";
import GoogleCallback from "./pages/GoogleCallback";
import Pending from "./pages/Pending";
import Dashboard from "./pages/Dashboard";
import POS from "./pages/POS";
import Inventory from "./pages/Inventory";
import Customers from "./pages/Customers";
import Suppliers from "./pages/Suppliers";
import Wallets from "./pages/Wallets";
import Sales from "./pages/Sales";
import Users from "./pages/Users";
import Repairs from "./pages/Repairs";
import ShiftHandover from "./pages/ShiftHandover";
import ClientWallet from "./pages/ClientWallet";

// Role constants to avoid creating new arrays on every render
const ROLES_PENDING = ["pending"];
const ROLES_CLIENT = ["cliente"];
const ROLES_ADMIN = ["admin"];
const ROLES_STAFF = ["admin", "vendedor"];

const withLayout = (Component) => (
  <Layout><Component /></Layout>
);

// Stable toast options - declared outside component to avoid new reference on every render
const TOAST_OPTIONS = {
  style: {
    background: 'rgba(15, 17, 21, 0.95)',
    border: '1px solid rgba(0, 255, 212, 0.2)',
    color: '#fff',
    fontFamily: 'Manrope, sans-serif',
  },
};

function AppRouter() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/auth/google" element={<GoogleCallback />} />
      <Route path="/pending" element={
        <ProtectedRoute roles={ROLES_PENDING}><Pending /></ProtectedRoute>
      } />

      <Route path="/mi-billetera" element={
        <ProtectedRoute roles={ROLES_CLIENT}><ClientWallet /></ProtectedRoute>
      } />

      <Route path="/dashboard" element={
        <ProtectedRoute roles={ROLES_STAFF}>{withLayout(Dashboard)}</ProtectedRoute>
      } />
      <Route path="/pos" element={
        <ProtectedRoute roles={ROLES_STAFF}>{withLayout(POS)}</ProtectedRoute>
      } />
      <Route path="/inventario" element={
        <ProtectedRoute roles={ROLES_STAFF}>{withLayout(Inventory)}</ProtectedRoute>
      } />
      <Route path="/reparaciones" element={
        <ProtectedRoute roles={ROLES_STAFF}>{withLayout(Repairs)}</ProtectedRoute>
      } />
      <Route path="/cambio-turno" element={
        <ProtectedRoute roles={ROLES_STAFF}>{withLayout(ShiftHandover)}</ProtectedRoute>
      } />
      <Route path="/clientes" element={
        <ProtectedRoute roles={ROLES_STAFF}>{withLayout(Customers)}</ProtectedRoute>
      } />
      <Route path="/proveedores" element={
        <ProtectedRoute roles={ROLES_ADMIN}>{withLayout(Suppliers)}</ProtectedRoute>
      } />
      <Route path="/billeteras" element={
        <ProtectedRoute roles={ROLES_STAFF}>{withLayout(Wallets)}</ProtectedRoute>
      } />
      <Route path="/ventas" element={
        <ProtectedRoute roles={ROLES_STAFF}>{withLayout(Sales)}</ProtectedRoute>
      } />
      <Route path="/usuarios" element={
        <ProtectedRoute roles={ROLES_ADMIN}>{withLayout(Users)}</ProtectedRoute>
      } />

      <Route path="/" element={<Navigate to="/dashboard" replace />} />
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRouter />
        <Toaster
          theme="dark"
          position="top-right"
          toastOptions={TOAST_OPTIONS}
        />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;

